import { connect } from "react-redux";
import CategoryHeaderLinks from "./CategoryHeaderLinks";
import { getCategoryHeaderLinks } from "../../../state/modules/category/selectors/composeCategoryHeaderLinks";

const mapStateToProps = state => ({
  links: getCategoryHeaderLinks(state)
});

export default connect(mapStateToProps)(CategoryHeaderLinks);
